import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api/notice-banners`;

export const getActiveNoticeBanners = () => axios.get(BASE_URL);
export const getAllNoticeBanners = () => axios.get(`${BASE_URL}/admin/all`, authHeader());
export const createNoticeBanner = (data) => axios.post(BASE_URL, data, authHeader());
export const updateNoticeBanner = (id, data) => axios.put(`${BASE_URL}/${id}`, data, authHeader());
export const deleteNoticeBanner = (id) => axios.delete(`${BASE_URL}/${id}`, authHeader());